import { MarketingNav, Footer } from "@/components/marketing/MarketingNav";
import { ShieldCheck, Lock, KeyRound, FileWarning, ServerCog, EyeOff } from "lucide-react";

const ITEMS = [
  [Lock, "Secure sessions", "JWT-based authentication with bcrypt password hashing and brute-force lockout on repeated failures."],
  [KeyRound, "Server-side secrets", "API keys and provider credentials live only in server-side environment variables — never exposed to the browser."],
  [ServerCog, "Provider abstraction", "Market data, calendar, news, AI, notifications and payments sit behind clean interfaces, so no single vendor is hard-wired."],
  [EyeOff, "No credential logging", "Passwords and secrets are never written to logs. Structured logging with error handling throughout."],
  [FileWarning, "Honest data states", "Data is labelled LIVE, DELAYED, STALE, SIMULATED or UNAVAILABLE. Stale data pauses new trade analysis automatically."],
  [ShieldCheck, "Safety-first release", "No autonomous live-money order execution in the first release. Paper trading only, with a hard risk circuit breaker."],
];

export default function Security() {
  return (
    <div className="bg-[var(--bg)] text-[var(--text)] min-h-screen">
      <MarketingNav />
      <section className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-20">
        <span className="text-xs uppercase tracking-wider text-aurum font-medium">Security & safety</span>
        <h1 className="mt-3 text-4xl lg:text-5xl font-extrabold tracking-tight max-w-2xl">Built to protect your capital and your data.</h1>
        <div className="mt-12 grid md:grid-cols-2 gap-5">
          {ITEMS.map(([Icon, t, d]) => (
            <div key={t} className="rounded-xl border border-[var(--border2)] bg-[var(--card2)] p-6 flex gap-4">
              <div className="h-10 w-10 shrink-0 rounded-lg flex items-center justify-center" style={{ background: "rgba(33,197,142,0.12)" }}><Icon size={19} className="text-bull" /></div>
              <div><h3 className="font-semibold">{t}</h3><p className="mt-1.5 text-sm text-[var(--text-sec)]">{d}</p></div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
